/* Imports */
import React from 'react'

/* Text Functional Component */
function Text(props) {
  return (
    <span className='capitalize text-xs mt-3 text-white'>{props.text}</span>
  )
}

/* Exports */
export default Text;